import React from 'react';
import {Card, CardContent, CardHeader, AppBar } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  content: {
    color: theme.palette.primary.contrastText,
  }
});

const Pane = (props) => {
  const { classes, header, subheader, filterTabs } = props;
  return (
  <Card style={{height: '85vh'}}>
    <AppBar position='static'>
      <CardHeader
        classes={{
          title: classes.content,
          subheader: classes.content
        }}
        title={header}
        subheader={subheader}
      />
      {filterTabs ? filterTabs : null}
    </AppBar>
    <CardContent style={{height: '100%', maxHeight: '72vh', overflowY: 'auto'}}>
      {props.children}
    </CardContent>
  </Card>
  )
}

export default withStyles(styles)(Pane);


// WEBPACK FOOTER //
// ./src/components/containers/Pane.js